import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './EmailFeedback.css';
import { useUser } from '../../context/UserContext';
import { API_BASE_URL } from '../../config/apiConfig';

function EmailFeedback() {
  const [searchParams] = useSearchParams();
  const emailName = searchParams.get('email_name');
  const feedback = searchParams.get('feed_back');
  const userEmail = searchParams.get('user_email');
  const navigate = useNavigate();
  const {user} = useUser();
  console.log("EmailFeedback user",user)

  // Call API with forwarded query params on mount
  useEffect(() => {
    if (emailName && feedback && userEmail) {
      const apiURL = `${API_BASE_URL}/email_feed_back/save?email_name=${encodeURIComponent(
        emailName
      )}&feed_back=${encodeURIComponent(feedback)}&user_email=${encodeURIComponent(userEmail)}`;

      fetch(apiURL, {
        method: 'GET',
      })
        .then((res) => {
          console.log('✅ API call success:', res.status);
        })
        .catch((err) => {
          console.error('❌ API call failed:', err);
        });
    }
  }, [emailName, feedback, userEmail]);

  return (
    <div className="efb-overlay">
      <div className="efb-popup-card">
        <div className="efb-icon-wrapper">
          <svg className="efb-icon" viewBox="0 0 24 24">
            <path d="M2 21L23 12L2 3V10L17 12L2 14V21Z" fill="#6366f1" />
          </svg>
        </div>

        <h2 className="efb-heading">✨ Feedback Received!</h2>

        <p className="efb-description">
        Thank you for your valued insight.<br />
        Your feedback helps us get things right.
        </p>



        <p className="efb-user-email">
          Submitted by: <span className="efb-email">{userEmail || 'Anonymous'}</span>
        </p>

        <button onClick={(e) =>{
            e.preventDefault();
            e.stopPropagation();
            if(!user){
                navigate("/")
            }else{
                if (user?.role_key=="SUPER_ADMIN") {
                    navigate("/users")
                }else{
                    navigate("/clients_accounts")
                }
            }
        
        }
            } className="efb-back-btn">
          ⬅ Back to Dashboard
        </button>
      </div>
    </div>
  );
}

export default EmailFeedback;
